import { Locale } from 'types';

export const preBillingAdjustmentTranslations = {
  [Locale.en]: {
    helmetTitle: 'Solar Agreement Update | LightReach',
    heading: 'We are updating your solar agreement',
    fullContract: 'Full contract',
    accept: 'Accept',
    acceptDisclaimer: 'By clicking Accept, you agree to the terms of this amendment.',
    contractExpires: 'Offer expires on',
    errorLoading: 'Unable to load your offer. Please try again.',
    expired: 'Sorry, this offer has expired.',
    voided: 'This offer has been voided.',
    accepted: 'This offer has been accepted.',
    acceptError: 'Something went wrong. Please try again.',
    confirmationHeading: 'You are all set',
    confirmationBodySolo: 'We have sent you a copy of the updated contract to',
    confirmationBodyAdditionalSignersBefore: 'Your signature has been recorded. We have also sent the agreement to',
    confirmationBodyAdditionalSignersAfter: 'to complete their signature.',
    confirmationQuestion: 'Do you have more questions?',
    confirmationContactBefore: 'Reach out to',
    confirmationOr: 'or',
    contactEmail: 'help@lightreach.com',
    contactPhone: '(800) 597-8527',
  },
  [Locale.es]: {
    helmetTitle: 'Actualización del Acuerdo Solar | LightReach',
    heading: 'Estamos actualizando su acuerdo solar',
    fullContract: 'Contrato completo',
    accept: 'Aceptar',
    acceptDisclaimer: 'Al hacer clic en Aceptar, usted acepta los términos de esta enmienda.',
    contractExpires: 'La oferta vence el',
    errorLoading: 'No se puede cargar su oferta. Por favor, inténtelo de nuevo.',
    expired: 'Lo sentimos, esta oferta ha expirado.',
    voided: 'Esta oferta ha sido anulada.',
    accepted: 'Esta oferta ha sido aceptada.',
    acceptError: 'Algo salió mal. Por favor, inténtelo de nuevo.',
    confirmationHeading: 'Todo listo',
    confirmationBodySolo: 'Le hemos enviado una copia del contrato actualizado a',
    confirmationBodyAdditionalSignersBefore: 'Su firma ha sido registrada. También hemos enviado el acuerdo a',
    confirmationBodyAdditionalSignersAfter: 'para que completen su firma.',
    confirmationQuestion: '¿Tiene más preguntas?',
    confirmationContactBefore: 'Comuníquese con',
    confirmationOr: 'o',
    contactEmail: 'help@lightreach.com',
    contactPhone: '(800) 597-8527',
  },
};
